import { render, staticRenderFns } from "./CreateFemaleAvatar.vue?vue&type=template&id=1567145c&"
import script from "./CreateFemaleAvatar.vue?vue&type=script&lang=js&"
export * from "./CreateFemaleAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports